import { Stack } from 'component-library';
import { Trans, useTranslation } from 'react-i18next';

import { METHODOLOGY_EXPLAINER_PAGE_HABITAT_INTACTNESS } from '@/config/constants';
import { useMethodologyPageLink } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useMethodologyPageLink';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

const LABELS = {
  howDoWeMeasureThis: 'global.howDoWeMeasureThis',
  howDoWeMeasureThisTitle:
    'shared.ncaDetail.ecologicalIntegrity.breakdown.habitatIntactness.explainers.howDoWeMeasure.title',
} as const;

export const HabitatIntactnessExplainerVNU = () => {
  const { t } = useTranslation();
  const methodologyPageLink = useMethodologyPageLink();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='habitat-intactness-explainer'>{t(LABELS.howDoWeMeasureThis)}</ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t(LABELS.howDoWeMeasureThisTitle)}</ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              body={
                <div className='columns-1 leading-[22px] text-text-secondary md:columns-2 lg:columns-3'>
                  <Trans
                    i18nKey='shared.ncaDetail.ecologicalIntegrity.breakdown.habitatIntactness.explainers.howDoWeMeasure.bodyVNU'
                    components={{
                      ol: <ol className='ml-6 list-decimal space-y-2.5' />,
                      li: <li />,
                    }}
                  />
                </div>
              }
            />
          </ExplainerBody>
          <MethodologyLink to={methodologyPageLink} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};

export const HabitatIntactnessExplainerBU = () => {
  const { t } = useTranslation();
  const methodologyPageLink = useMethodologyPageLink();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='habitat-intactness-explainer'>{t(LABELS.howDoWeMeasureThis)}</ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t(LABELS.howDoWeMeasureThisTitle)}</ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              title={t(
                'shared.ncaDetail.ecologicalIntegrity.breakdown.habitatIntactness.explainers.howDoWeMeasure.titleBU',
              )}
              body={t(
                'shared.ncaDetail.ecologicalIntegrity.breakdown.habitatIntactness.explainers.howDoWeMeasure.bodyBU',
              )}
            />
          </ExplainerBody>
          <MethodologyLink to={methodologyPageLink} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};

export const HabitatIntactnessExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='habitat-intactness-landler-explainer'>
        {t(LABELS.howDoWeMeasureThis)}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t(LABELS.howDoWeMeasureThisTitle)}</ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              title={t(
                'shared.ncaDetail.ecologicalIntegrity.breakdown.habitatIntactness.explainers.howDoWeMeasure.titleBU',
              )}
              body={
                <Trans
                  i18nKey='shared.ncaDetail.ecologicalIntegrity.breakdown.habitatIntactness.explainers.howDoWeMeasure.bodyLandler'
                  components={{
                    p: <p />,
                    br: <br />,
                  }}
                />
              }
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_HABITAT_INTACTNESS} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
